import { useState } from "react";
import AgentModal from "../AgentModal";
import { agentSection } from "../../content";

export default function AgentSection({ sectionTint }) {
  const [openAgent, setOpenAgent] = useState(false);

  return (
    <section
      id="agent"
      className={`border-t border-white/5 ${sectionTint}`}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 flex items-center justify-between flex-wrap gap-4">
        <div>
          <h2 className="text-2xl font-bold mb-2 font-mono">
            {agentSection.heading}
          </h2>
          <p className="text-slate-300 max-w-prose">
            {agentSection.blurb}
          </p>
        </div>
        <button
          onClick={() => setOpenAgent(true)}
          className="inline-flex items-center gap-2 rounded-2xl bg-indigo-400/90 hover:bg-indigo-300 text-slate-900 font-semibold px-5 py-3 transition shadow-lg shadow-indigo-500/10"
        >
          {agentSection.cta}
        </button>
      </div>

      {/* Drawer modal */}
      <AgentModal open={openAgent} onClose={() => setOpenAgent(false)} />
    </section>
  );
}
